import { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LayoutDashboard, CalendarCheck, CalendarDays, CreditCard, Users, Wrench, Clock, Mic2, Disc3, Newspaper, Sparkles, Inbox, Settings, LogOut, Menu, X, ExternalLink } from "lucide-react";

const LINKS = [
  ["", "Tableau de bord", LayoutDashboard],
  ["reservations", "Réservations", CalendarCheck],
  ["calendrier", "Calendrier", CalendarDays],
  ["paiements", "Paiements", CreditCard],
  ["clients", "Clients", Users],
  ["services", "Services & Tarifs", Wrench],
  ["disponibilites", "Disponibilités", Clock],
  ["artistes", "Artistes", Mic2],
  ["projets", "Projets", Disc3],
  ["actualites", "Actualités", Newspaper],
  ["culturels", "Projets culturels", Sparkles],
  ["demandes", "Demandes", Inbox],
  ["parametres", "Paramètres", Settings],
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const doLogout = () => { logout(); nav("/admin/login"); };

  return (
    <div className="min-h-screen bg-[#0A0A0C] flex">
      {/* Sidebar */}
      <aside className={`fixed lg:static inset-y-0 left-0 z-40 w-64 bg-[#0D0D11] border-r border-white/10 flex flex-col transition-transform ${open ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}>
        <div className="p-5 border-b border-white/10 flex items-center justify-between">
          <div className="font-display font-black text-sm tracking-[0.15em]">AL<span className="text-gold">MUSIC</span></div>
          <button className="lg:hidden text-slate-400" onClick={() => setOpen(false)}><X size={18} /></button>
        </div>
        <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-1">
          {LINKS.map(([to, label, Icon]) => (
            <NavLink key={to} to={`/admin/${to}`} end={to === ""} onClick={() => setOpen(false)} data-testid={`admin-nav-${to || "dashboard"}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition ${isActive ? "bg-amber-400/10 text-gold" : "text-slate-400 hover:text-white hover:bg-white/5"}`}>
              <Icon size={17} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10 space-y-1">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-slate-400 hover:text-white hover:bg-white/5"><ExternalLink size={16} /> Voir le site</a>
          <button onClick={doLogout} data-testid="admin-logout" className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-slate-400 hover:text-red-400 hover:bg-white/5"><LogOut size={16} /> Déconnexion</button>
        </div>
      </aside>

      {open && <div className="fixed inset-0 bg-black/50 z-30 lg:hidden" onClick={() => setOpen(false)} />}

      {/* Main */}
      <div className="flex-1 min-w-0">
        <header className="sticky top-0 z-20 backdrop-blur-md bg-black/70 border-b border-white/10 px-5 h-16 flex items-center justify-between">
          <button className="lg:hidden text-white" onClick={() => setOpen(true)}><Menu size={22} /></button>
          <div className="text-sm text-slate-500 ml-auto">{user?.email}</div>
        </header>
        <div className="p-5 lg:p-8">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
